import {isEmpty, find} from 'lodash'
import {userBulkEdit, getIamRole,changeOrganisationPeopleRole} from '@/libs/api/api'
import constants from '@/libs/constant/constants';
import pageRoute from '@/libs/constant/pageRoutes'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import {message ,loader, errorHandler, logout,routeErrorHandler} from '@/libs/helper';
export default {
    name: 'ChangeRole',
    mixins: [OrganisationRolesErrorHandlerMixin],
    // mixins: [bulkUpload],
    props: {
        selectedUser: {
            type: Object,
            default: () => {}
        },
        organsiationID: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            isEmpty,
            step: 1,
            selectedRoleId:null,
            isFinal: false,
            isProgress: false,
            isConfirm: false,
            progress: 0,
            rolesList: [],
            roleSelected:'',
            userRoleSelected: ''
        }
    },
    computed:{
        calledFromPeolpe() {
            const routePath = this.$route.path;
            const regex = /\/ip\/organisations\/[^/]+\/(people)/;
            const match = routePath.match(regex);
            return match ? match[1] : null;
          },
    },
    mounted() {
        this.fetchIamRoles()
    },
    methods: {
        /**
         * to update the role of people
         * @param {*} people 
         */
         async updatePersonRights(people) {            
            try {
                loader(this, true)
                // body for api
                let body = {
                    member:people._id,
                    organisation: this.organsiationID,
                    role: this.selectedRoleId
                }                    
                // api call
                let response = await changeOrganisationPeopleRole(body)
                if (response.success) {
                    this.isProgress = true
                    this.progress = 15
                    loader(this, false)
                    if (this.$store.getters.getUserInformation.id === people._id) {
                        // update org roles and permissions
                        this.$store.dispatch('setUpdateOrganisationRoles', true)
                        // route to overview page
                        this.$router.push({name: pageRoute.organisationOverview, params: {id: this.$route.params.id || this.$attrs.currentOrganisation._id}})
                    }
                    message(this, constants.messageType.SUCCESS, 'Role changed successfully')
                    this.progress = 100
                    this.step = 3
                    this.isFinal = true
                    this.$emit("refresh-table");
                }
            }
            catch (error) {
                loader(this, false)  
                this.isProgress = false
                console.log("error",error)
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
        },
        async fetchIamRoles() {
            loader(this, true)
            let params = ''
            let searchValue = ''
            let body = {
                searchText: searchValue,
                type: this.selectedUser.is_collaborator ? 'COLLABORATOR' : 'ORGANISATION'

            }
            await getIamRole(this.organsiationID, params, body)
                .then((response) => {
                    loader(this, false)
                    this.rolesList = response.result.items.map((role) => {
                        return {
                            role: role.name,
                            _id: role._id
                        }
                    })
                })
                .catch((error) => {
                    message(this, constants.messageType.ERROR, (error))
                    loader(this, false)
                })
        },
        async confirmButton() {
            let userId =  []
            userId.push(this.selectedUser.id)
            let body = {
                memberRole: this.roleSelected,
                organisationId: this.organsiationID,
                group_members: userId,

            }
            try {
                // if 'calledFromPeolpe' is set and matches 'people'
                if (this.calledFromPeolpe === 'people') {
                  // Call the updatePersonRights function
                  await this.updatePersonRights(this.selectedUser)
                } else {
                  // Call the userBulkEdit API
                  this.isProgress = true
                  this.progress = 15
                  const bulkEditResponse = await userBulkEdit(body)
                  this.progress = 100
                  message(this, constants.messageType.SUCCESS, bulkEditResponse.message)
                  this.step = 3
                  this.isFinal = true
                }
              } catch (error) {
                message(this, constants.messageType.ERROR, error.message)
                this.isProgress = false
              }
        },
        changeRole(id){
            this.selectedRoleId = id
            let roleName = find(this.rolesList, {_id : (id)})
            this.userRoleSelected = roleName.role
        },
        buttonAction (type) {
            switch (type) {
                case 'back':
                    this.step = 1
                    this.isConfirm = false
                    break
                case 'cancel':
                    this.$emit('close')
                    break
                case 'next':    
                    if (this.roleSelected) {
                        this.step = 2
                        this.isConfirm = true
                    }
                    break
                case 'done':
                    this.$emit('refreshPage')
                    this.$emit('close')
                    break    
            }
        },
    }
}